<div class="bg-testimonial">
    <div class="container pt-5 pb-5">
        <div class="row align-items-center justify-content-center">
            <div class="col-12 text-center">
                <div class="new-comers-content">
                    <h3>Ils parlent de nous</h3>
                    <!-- <h4 class="dash"></h4> -->
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid pb-2">
        <div class="testimonials-wrap-slides">
            <owl-carousel-o [options]="testimonialsWrapSlides">
                <ng-template carouselSlide>
                    <div class="testimonials-wrap-slides-item">
                        <div class="client-info d-flex align-items-center justify-content-center">
                            <img src="../../../../assets/images/new/Avatar.jpg" class="rounded-circle" alt="image">
                        </div>
                        <p class="mission-text">"L’approche pédagogique innovante du centre permet aux enfants de progresser tout en s’épanouissant. Une belle expérience éducative !".</p>
                        <div class="title text-center mt-3">
                            <h3 class="mission-text-bold">Pauline A.</h3>
                            <span>Parent</span>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="testimonials-wrap-slides-item">
                        <div class="client-info d-flex align-items-center justify-content-center">
                            <img src="https://i.ibb.co/8x9xK4H/team.jpg" class="rounded-circle" alt="image">
                        </div>
                        <p class="mission-text">"L’approche pédagogique innovante du centre permet aux enfants de progresser tout en s’épanouissant. Une belle expérience éducative !".</p>
                        <div class="title text-center mt-3">
                            <h3 class="mission-text-bold">James A.</h3>
                            <span>Parent</span>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="testimonials-wrap-slides-item">
                        <div class="client-info d-flex align-items-center justify-content-center">
                            <img src="../../../../assets/images/new/Avatar.jpg" class="rounded-circle" alt="image">
                        </div>
                        <p class="mission-text">"L’approche pédagogique innovante du centre permet aux enfants de progresser tout en s’épanouissant. Une belle expérience éducative !"</p>
                        <div class="title text-center mt-3">
                            <h3 class="mission-text-bold">Pauline A.</h3>
                            <span>Parent</span>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="testimonials-wrap-slides-item">
                        <div class="client-info d-flex align-items-center justify-content-center">
                            <img src="https://i.ibb.co/8x9xK4H/team.jpg" class="rounded-circle" alt="image">
                        </div>
                        <p class="mission-text">"L’approche pédagogique innovante du centre permet aux enfants de progresser tout en s’épanouissant. Une belle expérience éducative !"</p>
                        <div class="title text-center mt-3">
                            <h3 class="mission-text-bold">James A.</h3>
                            <span>Parent</span>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>